import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorage } from '../services/local-storage';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router,
    private storage: LocalStorage
  ) {}

  canActivate(): boolean {
    const  token = this.storage.getData('token');
    if (token) {
      return true; //  Allow access
    } else {
      this.router.navigate(['/login']); // Redirect to login
      return false;
    }
  }
}
